var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticsPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4359_15836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 42.707C0.5 19.5111 19.304 0.707031 42.5 0.707031C65.696 0.707031 84.5 19.5111 84.5 42.707C84.5 65.903 65.696 84.707 42.5 84.707C19.304 84.707 0.5 65.903 0.5 42.707Z",
    fill: "url(#paint0_linear_4359_15836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.46 49.987V56.147C51.46 56.7569 42.5 58.6032 42.5 58.6032C42.5 58.6032 33.54 57.017 33.54 56.147C33.54 54.5006 33.5736 46.235 33.54 38.5597C29.527 33.3581 29.527 30.107 32.7 26.747C35.8729 23.387 58.46 21.707 58.46 21.707C58.46 21.707 60.1545 38.0058 60.42 42.427C60.5266 44.205 61.68 49.987 57.2 49.987H51.46Z",
    fill: "url(#paint1_linear_4359_15836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4599 49.4628V52.8332C45.4587 51.7643 42.0054 49.5094 41.0999 46.0684C43.7132 47.8417 47.0732 48.9617 51.1799 49.4284C51.2732 49.439 51.3665 49.4505 51.4599 49.4628Z",
    fill: "#DE6530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8999 68.8333C73.677 72.4466 75.077 78.4199 76.0999 86.7533H8.8999C9.92321 78.419 11.3232 72.4456 13.0999 68.8333C14.8706 65.2327 31.2999 58.3027 31.2999 58.3027L53.6999 58.3008C53.6999 58.3008 70.1325 65.24 71.8999 68.8333Z",
    fill: "url(#paint2_linear_4359_15836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4599 60.068L45.8599 85.828H39.1399L40.5399 60.068C40.5399 60.068 41.8467 58.668 42.4999 58.668C43.1531 58.668 44.4599 60.068 44.4599 60.068Z",
    fill: "url(#paint3_linear_4359_15836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7432 65.281L40.3931 62.7677L40.5398 60.068C41.411 59.1346 42.0643 58.668 42.4998 58.668C42.9353 58.668 43.5886 59.1346 44.4598 60.068L44.7432 65.281Z",
    fill: "#D24B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 58.6655L39.7 63.708L31.02 58.388L33.54 54.748L42.5 58.0579L51.46 54.748L53.98 58.388L45.3 63.708L42.5 58.6655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1855 30.1652C36.2951 29.4006 35.2131 28.8856 33.6838 29.6803C30.0581 31.5627 32.4644 38.8254 36.5219 38.6837C37.9219 38.635 37.2801 41.4249 33.5399 43.2676C33.5399 40.3276 29.0599 33.0476 28.6679 26.4194C24.1599 24.7408 25.2799 18.0244 28.3747 18.0244C27.8808 11.867 37.7399 8.68673 41.5574 12.22C45.4399 7.56673 55.2399 9.94673 55.8315 13.9838C62.5703 10.3866 66.9999 20.7267 60.6901 24.7408C58.0936 26.3928 52.0199 27.0214 43.2522 27.0214C39.0449 27.0214 41.4644 36.869 42.7799 40.0476C44.4599 44.1076 53.8399 44.6676 56.7799 44.2476C59.0759 43.9197 60.2799 42.9876 60.4199 42.4276C62.5199 48.0276 59.8599 51.3876 55.6599 51.3876C48.5199 51.3876 41.3799 49.2876 40.2599 44.1076C39.3683 39.9851 39.4173 33.332 37.1855 30.1652Z",
    fill: "url(#paint4_linear_4359_15836)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4359_15836",
    x1: 42.5,
    y1: 84.707,
    x2: 42.5,
    y2: 0.707031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4359_15836",
    x1: 45.5232,
    y1: 21.707,
    x2: 45.5232,
    y2: 58.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4359_15836",
    x1: 42.4999,
    y1: 58.3008,
    x2: 42.4999,
    y2: 86.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#130027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4359_15836",
    x1: 42.4999,
    y1: 85.828,
    x2: 42.4999,
    y2: 58.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4359_15836",
    x1: 44.6974,
    y1: 9.66602,
    x2: 44.6974,
    y2: 51.3876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#130027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130017"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4359_15836"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 42.707C0.5 19.5111 19.304 0.707031 42.5 0.707031C65.696 0.707031 84.5 19.5111 84.5 42.707C84.5 65.903 65.696 84.707 42.5 84.707C19.304 84.707 0.5 65.903 0.5 42.707Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsPic);
export default __webpack_public_path__ + "static/media/analyticsPic.6bd009dacc0714286d62b62de31df4ec.svg";
export { ForwardRef as ReactComponent };